exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field-profile-image{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/dist/cjs.js!./src/components/FieldProfileImage/style.scss
// module id = 6460
// module chunks = 0